import actions from "@state/actions";
import { getOEMName } from "./editor";
import { Dispatch } from "redux";
import { IUserAccess } from "@state/userAccess/types";
import { Industry } from "@state/industries/types";
import { ISelectedIndustry } from "@routes/private/UserManagement/components/UserModal/types";
import { IBrandDefinition, IDSConfig } from "@state/dsconfig/types";

export const USER_ACCESS_FILTERS = [
  { title: "Name: ", extra:'(A-Z)', text:"Name (A-Z)", query:"c.user.name"},
  { title: "Name: ", extra:'(Z-A)', text:"Name (Z-A)", query:"c.user.name DESC"},
  { title: "Last Active: ", extra:'(New to Old)', text:"Last Active (New to Old)", query:"c.lastActive DESC"},
  { title: "Last Active: ", extra:'(Old to New)', text:"Last Active (Old to New)", query:"c.lastActive"},
  { title: "Date Added: ", extra:'(New to Old)', text:"Date Added (New to Old)", query:"c.createdDate DESC"},
  { title: "Date Added: ", extra:'(Old to New)', text:"Date Added (Old to New)", query:"c.createdDate"}
]

export const DEFAULT_USER_FILTER = USER_ACCESS_FILTERS[4].query

const MINIMAL_PERMISSION = "48";

export const addNewUserAccessInList = (list: IUserAccess[], newUserAccess: IUserAccess) => {
  return [newUserAccess, ...list]
}

export const updateUserAccessInList = (list: IUserAccess[], newUserAccess: IUserAccess) => {
  return list.map(userAccess => {
    if (userAccess.id === newUserAccess.id) return newUserAccess
    return userAccess
  })
}

export const industryToSelected = (industry: Industry): ISelectedIndustry => {
  return {
    id: industry.id,
    name: industry.name,
    brands: industry.brands,
  }
}

export const findIndustryFromBrandId = (industries: Industry[], brandId: string): Industry | undefined => {
  return industries.find(i => i.brands.find(b => b === brandId))
}

export const findBrandNames = (brands: IBrandDefinition[], brandIds: string[]) => {
  const selectedBrands: string[] = []
  brandIds.forEach(id => {
    const brand = brands.find(b => b.id === id)
    if (brand) selectedBrands.push(brand.name)
  })
  return selectedBrands.sort()
}

export const handleRemoveBrand = (dispatch: Dispatch, userAccess: IUserAccess | undefined, industries: Industry[], oemId: string) => {
  if (userAccess?.brands && industries.length) {
    let brands = [...userAccess.brands.map(b => b.id)]
    userAccess.industriesAllAccess?.forEach(industryId => {
      const industry = industries.find(i => i.id === industryId)
      if (industry) brands = brands.concat(industry.brands)
    })
    if (!brands.find(b => b === oemId))
      dispatch(actions.dsConfig.removeBrand(oemId))
  }
}

export const getAllBrands = (dsConfig: IDSConfig, userAccess: IUserAccess, industries: Industry[]) => {
  let brands = [...(userAccess.brands ?? [])]
  userAccess.industriesAllAccess?.forEach(industryId => {
    const industry = industries.find(i => i.id === industryId)
    if (industry) {
      brands = brands.concat(industry.brands.map(brandId => {
        return {id: brandId, name: getOEMName(brandId, dsConfig)}
      }))
    }
  })
  userAccess.brands = brands.sort((a, b) => a.name < b.name ? -1 : 1)
  return userAccess
}

export const hasMinimalPermissions = (currentProfile: any,origin : string): boolean => {
  if (!currentProfile) {
    return false;
  }

  if (currentProfile.role === 'Admin') {
    return true;
  }

  const permissionIds = currentProfile['dealeron.feature']
    ? currentProfile['dealeron.feature'].map((id: any) => String(id).trim())
    : [];

  const validPermissions = permissionIds.filter((id: string) => id !== "");

  if (validPermissions.includes(MINIMAL_PERMISSION) && origin !== 'createNew') {
    return false;
  }

  return true;
};



export const isAuthenticated = (user: any, requiredRoles: string[] | null = null): boolean => {
  if (!user || !user.access_token) {
      return false;
  }

  const currentTime = Math.floor(Date.now() / 1000);
  if (user.expires_at && user.expires_at < currentTime) {
      return false;
  }

  if (!requiredRoles || requiredRoles?.length === 0) {
      return true;
  }

  return requiredRoles?.includes(user.profile?.role);
};
